export const blogPosts = [
  {
    id: 1,
    title: "The Science Of Sleep",
    slug: "the-science-of-sleep",
    image: "/images/Bella/Blog Photos/The Science Of Sleep.JPG",
    date: "December 10, 2025",
    excerpt:
      "Discover the fascinating science behind quality sleep and how it impacts your daily life.",
  },
  {
    id: 2,
    title: "Why Smart Sleep Starts with Knowing Your Body",
    slug: "how-to-find-the-perfect-mattress",
    image: "/images/Bella/Product%20Photos/sensorAI.PNG",
    date: "December 5, 2025",
    excerpt:
      "How pressure & heat sensors are redefining the way we sleep",
  },
  {
    id: 3,
    title: "Inside the Craftsmanship Behind Bellaflex Mattresses",
    slug: "craftsmanship",
    image: "/images/Bella/Blog Photos/Craftsmanship.jpg",
    date: "November 28, 2025",
    excerpt:
      "Learn about the meticulous craftsmanship that goes into every Bella mattress.",
  },
];
